import { BaseControl } from "./BaseControl";
import { Controller } from "./Controller";
import * as ControlFactory from "../Common/ControlFactory";
import { app } from "../Frame/App";

export class AmpelControl extends BaseControl {

    constructor(protected div: HTMLElement, protected controller: Controller, field: string) {
        super(controller, field);

        div.classList.add("ampel");
        div.parentElement.style.cursor = "pointer";
        div.parentElement.addEventListener("click", this.onClickEvent);
    }

    onClickEvent = () => {
        let value = app.anyToInt(this.getModelValue(), 0);
        value++;
        if (value > 2) {
            value = 0;
        }
        this.saveValue(value);
        this.update();
    }

    dispose() {
        this.div.parentElement.removeEventListener("click", this.onClickEvent);
    }

    public onUpdate: () => void = null;

    update() {
        let value = app.anyToInt(this.getModelValue(), 0);
        this.div.classList.remove("ampel-green");
        this.div.classList.remove("ampel-yellow");
        this.div.classList.remove("ampel-red");
        switch (value) {
            case 0:
                this.div.classList.add("ampel-green");
                break;
            case 1:
                this.div.classList.add("ampel-yellow");
                break;
            case 2:
                this.div.classList.add("ampel-red");
                break;
        }
    }

    updateControlFromModel() {
        this.update();
    }

    updateModelFromControl() {
    }

    validate() {
    }

    focus() {
    }
}
